// Returns the correct API base URL
// In production (custom domain), use relative URLs (same origin)
// In preview, use the REACT_APP_BACKEND_URL
const getApiUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL || "";
  // If running on the same host as the API (production deploy), use relative URLs
  if (typeof window !== "undefined" && !window.location.hostname.includes("preview.emergentagent")) {
    return "";
  }
  return envUrl;
};

export const API_URL = getApiUrl();
